import { createContext } from 'react';

import {
  UbiquitiApiDataItem,
  UbiquitiFirewallZone,
} from '@totem/components/ubiquiti/types';

interface Context {
  loading: boolean;
  error: boolean;
  firewallZones: UbiquitiApiDataItem<UbiquitiFirewallZone>[];
}

export default createContext<Context>({
  loading: false,
  error: false,
  firewallZones: [],
});
